// Free version - simplified read-only Prospect Tracker
import React, { useEffect, useState, useMemo } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../../firebase";
import "../prospect-tracker.css";

export default function FreeProspectTracker() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const [prospects, setProspects] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Get filter from URL params
  const recruiterFilter = searchParams.get("recruiter");
  const nameFilter = searchParams.get("name");

  useEffect(() => {
    const fetchProspects = async () => {
      setLoading(true);
      try {
        let q = collection(db, "prospect_tracker");
        
        if (recruiterFilter) {
          q = query(q, where("recruiter", "==", recruiterFilter));
        }
        
        const snapshot = await getDocs(q);
        const data = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        // Apply name filter client-side if present
        const filtered = nameFilter
          ? data.filter(p => p.name?.toLowerCase().includes(nameFilter.toLowerCase()))
          : data;
        
        setProspects(filtered);
      } catch (err) {
        console.error("Error fetching prospects:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProspects();
  }, [recruiterFilter, nameFilter]);

  const handleReset = () => {
    navigate("/prospect-tracker-free");
  };

  return (
    <div className="tracker-page">
      <div className="tracker-header">
        <h1>Prospect Tracker (View Only)</h1>
        <button className="reset-btn" onClick={handleReset}>
          Reset Filters
        </button>
      </div>

      {loading ? (
        <div className="loading">Loading...</div>
      ) : (
        <div className="tracker-table-container">
          <table className="tracker-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Recruiter</th>
                <th>Status</th>
                <th>Licensed</th>
              </tr>
            </thead>
            <tbody>
              {prospects.length === 0 ? (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center", padding: "20px" }}>
                    No prospects found
                  </td>
                </tr>
              ) : (
                prospects.map(prospect => (
                  <tr key={prospect.id}>
                    <td>{prospect.name || "N/A"}</td>
                    <td>{prospect.email || "N/A"}</td>
                    <td>{prospect.phone || "N/A"}</td>
                    <td>{prospect.recruiter || "N/A"}</td>
                    <td>{prospect.status || "Active"}</td>
                    <td>{prospect.licensed ? "✓" : "—"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

